<!--
 * @Author: chenming
 * @LastEditors: Yu Weifeng weifeng.yu@gientech.com
 * @Description: 热力图
-->
<script>
import ChartBase from '../base.vue';
/******* echarts *********/
import * as echarts from 'echarts/core';
import { TooltipComponent, DatasetComponent, GridComponent, VisualMapComponent } from 'echarts/components';
import { HeatmapChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
/******* chart tools *********/
echarts.use([TooltipComponent, DatasetComponent, GridComponent, VisualMapComponent, HeatmapChart, CanvasRenderer]);
export default {
  name: 'LcChartHeatMap',
  mixins: [ChartBase],
  props: {},
  data() {
    return {
      chartClass: ['lc-chart__heatMap']
    };
  },
  created() {
    // preset
  },
  mounted() {},
  methods: {
    getCurrentEcharts() {
      return echarts;
    },
    processChartData(data) {
      const options = this.mapOptions;

      const transformData = data.map(item => {
        return [item[options?.xAxis || 'xAxis'], item[options?.yAxis || 'yAxis'], item[options?.valueMap || 'value']];
      });

      this.chartData = transformData;
    },
    processOptions(options) {
      if (Array.isArray(options['series'])) {
        options['series'][0]['data'] = this.chartData;
      } else {
        options['series']['data'] = this.chartData;
      }
      this.chartOptions = options;
    }
  }
};
</script>
